<!-- Left Hand Side -->
<div class="col-sm-3" id="locatetab">

	<!-- Header -->
	<h1 class="locate-page-header">
		<i class="fa fa-search" aria-hidden="true"></i> 
		MONITOR LOCATION
	</h1>
	
	<!-- Autoselect Controls -->
	<h4 class="row">
		<div class="col-sm-8"></div>
		<div class="col-sm-4">
		<input type="checkbox" class="styled" [(ngModel)]="autoselectInstances">
		<label for="checkbox" style="font-size: small;">&nbsp;Autoselect?</label>
		</div>
	</h4>
	
	<!-- Small Warning message if a Location is selected but not being tracked... TODO: We need a better indicator of this... -->
	<h4 *ngIf="!isSelectingLocation && selectedLocation != null && monitorLocationWsSubscription == null">
		NOT TRACKING LOCATION CHANGES! 
	</h4>

	<!-- Tab Navigation (People/Assets/Vehicles -->
	<ul class="nav nav-tabs">
		<li class="active">
			<a data-toggle="tab" href="#locationsTab">
				LOCATIONS
			</a>
		</li>
		<li [class.disabled]="!selectedLocation">
			<a [attr.data-toggle]="selectedLocation? 'tab' : ''" [href]="selectedLocation? '#peopleTab' : 'javascript:void(0)'">
				PEOPLE <span *ngIf="selectedLocation">({{ totalNumberOfPeople }}) [{{ peopleBeingTracked.size }}]</span>
			</a>
		</li>
		<li [class.disabled]="!selectedLocation">
			<a [attr.data-toggle]="selectedLocation? 'tab' : ''" [href]="selectedLocation? '#assetsTab' : 'javascript:void(0)'">
				ASSETS <span *ngIf="selectedLocation">({{ totalNumberOfAssets }}) [{{ assetsBeingTracked.size }}]</span>
			</a>
		</li>
	</ul>

	<!-- Tab Content (LOCATIONS / PEOPLE / ASSETS) -->
	<div class="tab-content tab-section" style="border: 0px solid">

		<!-- Locations Tab -->
		<div id="locationsTab" class="tab-pane fade in active">

			<!-- Locations Tab - Search Bar -->
			<div class="input-group locate-input">
				<input class="form-control" placeholder="Search for Locations..." #locationSearchInput >
			</div>

			<!-- Locations Tab - Location information -->
			<div class="locate-tab">
				<div class="locate-tab-scroll">
				<table class="table tablesorter tablesorter-default locate-table">

					<!-- Locations Column Headers -->
					<tbody>
						<tr class="header">
							<th>NAME</th>
						</tr>
					</tbody>

					<!-- Locations Data - Display Locations for selection -->
					<tbody id="locateTableLocations">

						<!-- If searching for Locations... Display a message indicating that.  -->
						<ng-container *ngIf="isSearchingLocations; else listLocationsTemplate">
							<div>Searching Locations...</div>
						</ng-container>

						<!-- Locations are not being searched for... Display the loaded Locations -->
						<ng-template #listLocationsTemplate>
							<!-- Create the Displays for each Location -->
							<ng-container *ngFor="let location of displayedLocations  | paginate: {id: 'location_pagination', itemsPerPage: resultsPerPageValues, currentPage: currentPageLocations, totalItems: totalNumberOfLocations }">
								<tr class="locateHeader" (click)="onLocationClicked(location)">
									<td [class.locationSelected]="location?.id == selectedLocation?.id">
										<i class="fa fa-map"></i> {{ location.name }}
									</td>
								</tr>
							</ng-container>
						</ng-template>
					</tbody>
				</table>
				</div>
				<!-- Pagination Controls for the Locations -->
				<pagination-controls class="pagination" id="location_pagination" (pageChange)="onLocationPageChange($event)"
					[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>
			</div>
		</div>
		<!-- End of Locations Tab -->

		<!-- People Tab -->
		<div id="peopleTab" class="tab-pane fade in">

			<!-- People Tab - Search Bar -->
			<div class="input-group locate-input">
				<input style="width: 75%" class="form-control" placeholder="Search for someone..." 
					#personSearchInput [(ngModel)]="personSearchValue" [disabled]="isPeopleSearchOptionChanging" >
				<select class="form-control" style="width: 25%" [(ngModel)]="selectedPersonSearchOption" (change)="onPeopleSearchOptionChanged()">
					<option *ngFor="let searchOption of peopleSearchOptions" [ngValue]="searchOption">
						{{ (searchOption?.searchType == "NAME"? "NAME" : (searchOption?.property?.name + " (" + searchOption?.property?.object?.name) + ")") }}
					</option>
				</select>
			</div>

			<!-- People Tab - People information -->
			<div class="locate-tab">
				<div class="locate-tab-scroll">
				<table class="table tablesorter tablesorter-default locate-table">

					<!-- Main Headers -->
					<tbody>
						<tr class="header">
							<th style="width: 0px;">
								<div class="checkbox checkbox-inline">
									<input type="checkbox" class="styled"
										(click)="selectAllPeople($event.target.checked)"
										[checked]="isAllPeopleBeingTracked()"
										[disabled]="isPeopleSearchOptionChanging || isSelectingAllPeople">
									<label></label>
								</div>
							</th>
							<th style="width: 0px;">ICON</th>
							<th>NAME</th>
							<th>ZONE</th>
						</tr>
					</tbody>
					
					<!-- People Data -->
					<tbody id="locateTablePeople" style="max-height: 90%; overflow-y: scroll">
						<!-- If searching for Locations... Display a message indicating that.  -->
						<ng-container *ngIf="isSearchingPeople || isPeopleSearchOptionChanging; else listPeopleTemplate">
							<span>Searching People...</span>
						</ng-container>

						<!-- Locations are not being searched for... Display the loaded Locations -->
						<ng-template #listPeopleTemplate>
							<!-- Create the Displays for each User -->
							<ng-container *ngFor="let person of peopleInList | paginate: {id: 'peopletype_pagination', itemsPerPage: resultsPerPageValues, currentPage: currentPage, totalItems: totalNumberOfPeople }">

								<!-- Main Label (Displayed by default) -->
								<tr class="locateHeader">
									<!-- Checkbox -->
									<td style="width: 16px">
										<div class="checkbox checkbox-inline">
											<input type="checkbox" class="styled" 
												[disabled]="isSelectingAllPeople || isPersonCheckboxBeingToggled(person)"
												(click)="onPersonCheckboxToggled(person, $event)" 
												[checked]="isInstanceTracked(person)"
												>
											<label></label>
										</div>
									</td>

									<!-- Person's Icon -->
									<td style="width: 16px" (click)="onListHeaderClicked(person)">
										<img [src]="getIconSource(person)" />
									</td>

									<!-- Person's Name -->
									<td (click)="onListHeaderClicked(person)">
										{{person.name }}
									</td>

									<!-- Person's Zone -->
									<td (click)="onListHeaderClicked(person)">
										{{person?.zoneInstance?.name }} <span *ngIf="isInstanceTracked(person) && !isInstanceActuallyTracked(person)"> - NOT TRACKED!</span>
									</td>
								</tr>

								<!-- Display Body -->
								<tr id="{{getIdForListBody(person)}}" 
									class="locateBody hidden" 
									style="background-color: #2f2f2f"
									>
									<td colspan="5">
										<table style="background-color: #2f2f2f; border: 0; width: 100%">
											<tbody>
												<!-- Image (only added if present) -->
												<tr class="user-image" *ngIf="isImagePresent(person)">
													<td rowspan="10">
														<img class="table-user-image" [src]="getImageSource(person)" />
													</td>
												</tr>

												<!-- Description -->
												<tr class="user-list">
													<td>{{person.description}}</td>
												</tr>

												<!-- Data for Main Display Properties (Main Display = TRUE) -->
												<ng-container *ngFor="let datum of person.data">
													<ng-container *ngIf="datum.property.mainDisplay == true">
														<tr>
															<td>{{ datum.property.name }}:</td>
															<td style="max-width: 400px">
																<ng-container *ngIf="datum.property.type == 'STRING'">
																	<ng-container *ngIf="datum.property.parameter == 'url'">
																		<a style="color: #e65100;" href="{{ datum.value }}" target="_blank">{{ datum.value }}</a>
																	</ng-container>
																	<ng-container *ngIf="datum.property.parameter != 'url'">
																		{{ datum.value }}
																	</ng-container>
																</ng-container>
																<ng-container *ngIf="datum.property.type != 'STRING'">
																	{{ datum.value }}
																</ng-container>
															</td>
														</tr>
													</ng-container>
												</ng-container>
												<!-- END OF: Data for Main Display Properties (Main Display = TRUE) -->
												
												<!-- Action(s) Button / "Full Details" Expand / Hide -->
												<tr>
													<td>
														<div class="dropdown btn-group" style="display:inline-block">
															<button type="button" class="btn btn-primary btn-xs dropdown-toggle" data-toggle="dropdown">Action(s)</button>
															<ul class="dropdown-menu">
																<li (click)="openDataDialog(person)"><a>Edit Data</a></li>
																<ng-container *ngIf="isContainsFunctions(person)">
																	<li class="divider"></li>
																	<ng-container *ngFor="let personFunction of person?.object?.functions">
																		<li (click)="openFunctionDialog(person, personFunction?.key)"><a>{{ personFunction?.name }}</a></li>
																	</ng-container>
																</ng-container>
															</ul>
														</div>
													</td>
													<td style="text-align: end; color:red;" class="locateBody">
														<ng-container *ngIf="isFullDetailsNeeded(person)">
															<span id="{{getIdForHideFullDetails(person)}}" style="display: none;" (click)="hideFullDetails(person)"> - Hide Full Details </span>
															<span id="{{getIdForShowFullDetails(person)}}" (click)="showFullDetails(person)"> + Show Full Details </span>
														</ng-container>												
													</td>
												</tr>
												<!-- END OF: Action(s) Button / "Full Details" Expand / Hide -->

												<!-- Full Details Display -->
												<tr id="{{getIdForFullDetails(person)}}" class="locateBody" *ngIf="isFullDetailsNeeded(person)"
													style="display: none; background-color: #2f2f2f" >
													<td colspan="5">
														<table style="background-color: #2f2f2f; border: 0; width: 100%">
															<tbody>
																<!-- Data for Properties NOT Main Display (Main Display = FALSE) -->
																<ng-container *ngFor="let datum of person.data">
																	<ng-container *ngIf="datum.property.mainDisplay == false">
																		<tr>
																			<td>{{ datum.property.name }}:</td>
																			<td style="max-width: 400px">
																				<ng-container *ngIf="datum.property.type == 'STRING'">
																					<ng-container *ngIf="datum.property.parameter == 'url'">
																						<a style="color: #e65100;" href="{{ datum.value }}" target="_blank">{{ datum.value }}</a>
																					</ng-container>
																					<ng-container *ngIf="datum.property.parameter != 'url'">
																						{{ datum.value }}
																					</ng-container>
																				</ng-container>
																				<ng-container *ngIf="datum.property.type != 'STRING'">
																					{{ datum.value }}
																				</ng-container>
																			</td>
																		</tr>
																	</ng-container>
																</ng-container>
																<!-- END OF: Data for Properties NOT Main Display (Main Display = FALSE) -->
															</tbody>
														</table>
													</td>
												</tr>
												<!-- END OF: Full Details Display-->
											</tbody>
										</table>
									</td>
								</tr>
							</ng-container>
						</ng-template>
					</tbody>
				</table>
				</div>
				<!-- Pagination Controls for the "People" Types (controls referenced in the *ngFor for the table data above) -->
				<pagination-controls class="pagination" id="peopletype_pagination" (pageChange)="onPageChange($event)"
					[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
				</pagination-controls>
			</div>
		</div>
		<!-- End of People Tab -->


		<!-- Assets Tab -->
		<div id="assetsTab" class="tab-pane fade">

			<!-- Assets Tab - Search Bar -->
			<div class="input-group locate-input">
				<input class="form-control" style="width: 75%;" placeholder="Search for something..." 
					#assetSearchInput [(ngModel)]="assetSearchValue" [disabled]="isAssetSearchOptionChanging">
				<select class="form-control" style="width: 25%" [(ngModel)]="selectedAssetSearchOption" (change)="onAssetSearchOptionChanged()">
					<option *ngFor="let searchOption of assetSearchOptions" [ngValue]="searchOption">
						{{ (searchOption?.searchType == "NAME"? "NAME" : (searchOption?.property?.name + " (" + searchOption?.property?.object?.name) + ")") }}
					</option>
				</select>
			</div>

			<div class="locate-tab">
				<div class="locate-tab-scroll">
				<table class="table tablesorter tablesorter-default locate-table">

					<!-- Main Headers -->
					<tbody>
						<tr class="header">
							<th style="width: 0px;">
								<div class="checkbox checkbox-inline">
									<input type="checkbox" class="styled"
										(click)="selectAllAssets($event.target.checked)"
										[checked]="isAllAssetsBeingTracked()"
										[disabled]="isSearchingAssets || isSelectingAllAssets">
									<label></label>
								</div>
							</th>
							<th style="width: 0px;">ICON</th>
							<th>NAME</th>
							<th>ZONE</th>
						</tr>
					</tbody>

					<!-- Asset Data -->
					<tbody id="locateTableAssets">

						<!-- If searching for Locations... Display a message indicating that.  -->
						<ng-container *ngIf="isSearchingAssets || isAssetSearchOptionChanging; else listAssetsTemplate">
							<span>Searching Assets...</span>
						</ng-container>

						<!-- Locations are not being searched for... Display the loaded Locations -->
						<ng-template #listAssetsTemplate>

							<!-- Create the Displays for each Asset -->
							<ng-container *ngFor="let asset of assetsInList  | paginate: {id: 'assettype_pagination', itemsPerPage: resultsPerPageValues, currentPage: currentPage, totalItems: totalNumberOfAssets }">

								<!-- Main Label (Displayed by default) -->
								<tr  class="locateHeader">
									<!-- Checkbox -->
									<td style="width: 16px">
										<div class="checkbox checkbox-inline">
											<input type="checkbox" class="styled" 
												[disabled]="isSelectingAllAssets || isAssetCheckboxBeingToggled(asset)"
												(click)="onAssetCheckboxToggled(asset, $event)" 
												[checked]="isInstanceTracked(asset)"
												>
											<label></label>
										</div>
									</td>

									<!-- Asset's Icon -->
									<td style="width: 16px" (click)="onListHeaderClicked(asset)">
										<img [src]="getIconSource(asset)" />
									</td>

									<!-- Asset's Name -->
									<td (click)="onListHeaderClicked(asset)">
										{{asset.name}} 
									</td>

									<!-- Zone -->
									<td (click)="onListHeaderClicked(asset)">
										{{asset?.zoneInstance?.name}} <span *ngIf="isInstanceTracked(asset) && !isInstanceActuallyTracked(asset)"> - NOT TRACKED!</span>
									</td>
								</tr>

								<!-- Display Body -->
								<tr id="{{getIdForListBody(asset)}}" 
									class="locateBody hidden" 
									style="background-color: #2f2f2f"
									>
									<td colspan="5">
										<table style="background-color: #2f2f2f; border: 0; width: 100%">
											<tbody>
												<!-- Image (only added if present) -->
												<tr class="user-image" *ngIf="isImagePresent(asset)">
													<td rowspan="10">
														<img class="table-user-image" [src]="getImageSource(asset)" />
													</td>
												</tr>

												<!-- Description -->
												<tr class="user-list">
													<td>{{asset.description}}</td>
												</tr>
												
												<!-- Data for Main Display Properties (Main Display = TRUE) -->
												<ng-container *ngFor="let datum of asset.data">
													<ng-container *ngIf="datum.property.mainDisplay == true">
														<tr>
															<td>{{ datum.property.name }}:</td>
															<td style="max-width: 400px">
																<ng-container *ngIf="datum.property.type == 'STRING'">
																	<ng-container *ngIf="datum.property.parameter == 'url'">
																		<a style="color: #e65100;" href="{{ datum.value }}" target="_blank">{{ datum.value }}</a>
																	</ng-container>
																	<ng-container *ngIf="datum.property.parameter != 'url'">
																		{{ datum.value }}
																	</ng-container>
																</ng-container>
																<ng-container *ngIf="datum.property.type != 'STRING'">
																	{{ datum.value }}
																</ng-container>
															</td>
														</tr>
													</ng-container>
												</ng-container>
												<!-- END OF: Data for Main Display Properties (Main Display = TRUE) -->
												
												<!-- Action(s) Button / "Full Details" Expand / Hide -->
												<tr>
													<td>
														<div class="dropdown btn-group" style="display:inline-block">
															<button type="button" class="btn btn-primary btn-xs dropdown-toggle" data-toggle="dropdown">Action(s)</button>
															<ul class="dropdown-menu">
																<li (click)="openDataDialog(asset)"><a>Edit Data</a></li>
																<ng-container *ngIf="isContainsFunctions(asset)">
																	<li class="divider"></li>
																	<ng-container *ngFor="let assetFunction of asset?.object?.functions">
																		<li (click)="openFunctionDialog(asset, assetFunction?.key)"><a>{{ assetFunction?.name }}</a></li>
																	</ng-container>
																</ng-container>
															</ul>
														</div>
													</td>
													<td style="text-align: end; color:red;" class="locateBody">
														<ng-container *ngIf="isFullDetailsNeeded(asset)">
															<span id="{{getIdForHideFullDetails(asset)}}" style="display: none;" (click)="hideFullDetails(asset)"> - Hide Full Details </span>
															<span id="{{getIdForShowFullDetails(asset)}}" (click)="showFullDetails(asset)"> + Show Full Details </span>
														</ng-container>												
													</td>
												</tr>
												<!-- END OF: Action(s) Button / "Full Details" Expand / Hide -->

												<!-- Full Details Display -->
												<tr id="{{getIdForFullDetails(asset)}}" class="locateBody" *ngIf="isFullDetailsNeeded(asset)"
													style="display: none; background-color: #2f2f2f" >
													<td colspan="5">
														<table style="background-color: #2f2f2f; border: 0; width: 100%">
															<tbody>
																<ng-container *ngFor="let datum of asset.data">
																	<ng-container *ngIf="datum.property.mainDisplay == false">
																		<tr>
																			<td>{{ datum.property.name }}:</td>
																			<td style="max-width: 400px">
																				<ng-container *ngIf="datum.property.type == 'STRING'">
																					<ng-container *ngIf="datum.property.parameter == 'url'">
																						<a style="color: #e65100;" href="{{ datum.value }}" target="_blank">{{ datum.value }}</a>
																					</ng-container>
																					<ng-container *ngIf="datum.property.parameter != 'url'">
																						{{ datum.value }}
																					</ng-container>
																				</ng-container>
																				<ng-container *ngIf="datum.property.type != 'STRING'">
																					{{ datum.value }}
																				</ng-container>
																			</td>
																		</tr>
																	</ng-container>
																</ng-container>
															</tbody>
														</table>
													</td>
												</tr>
												<!-- END OF: Full Details Display-->
											</tbody>
										</table>
									</td>
								</tr>
							</ng-container>
						</ng-template>
					</tbody>
				</table>
				</div>
			<!-- Pagination Controls for the "Asset" Types (controls referenced in the *ngFor for the table data above) -->
			<pagination-controls class="pagination" id="assettype_pagination" (pageChange)="onPageChange($event)"
				[directionLinks]="true" nextLabel="Next" previousLabel="Prev" [autoHide]="true">
			</pagination-controls>
			</div>
		</div>
		<!-- End of Assets Tab -->
	</div>
	<!-- End of Tabs Content -->

</div>
<!-- End of Left Hand Side -->

<!-- Right Hand Side -->
<div class="col-sm-9" style="margin: -10px 0 0 0; padding: 0; height: calc(100vh - 50px); overflow-y: hidden; background-image: url(assets/images/map_bg.png)">
	<!-- Canvas where everything is drawn -->
	<app-new-map #locateMap class="locate-map" 
		(onInstanceClicked)="onInstanceClicked($event)"
		>
	</app-new-map>
</div><!-- end of col-sm-8 -->

<!-- Popup Dialog used to execute Function Action(s) on Assets -->
<ef-instance-function-popup
	(functionCompletedSuccessfullyEvent)="onFunctionCompletedSuccessfully($event)"
	>
</ef-instance-function-popup>

<!-- Popup Dialog used execute the "Edit Data" Action on Assets -->
<ef-instance-data-dialog
	(updateCompletedSuccessfullyEvent)="onDataUpdatedSuccessfully($event)"
	>
</ef-instance-data-dialog>

<!-- Popup Dialogs for each tracked instances  -->
<ng-container *ngFor="let instance of getTrackedInstances()">
	<ef-instance-locate-popup
		[instance]="instance"
		[dialogId]="getIdForPopup(instance)"
		[hideEmitter]="getHideEmitter(instance)"
		>
	</ef-instance-locate-popup>
</ng-container>